export const BLANK = 'BYE';
// export const API_ENDPOINT = 'http://127.0.0.1:5001/darts-29a45/us-central1';
export const API_ENDPOINT = 'https://us-central1-darts-29a45.cloudfunctions.net';

// for display purposes only, checks are in backend
export const ADM = 'p2yiBD7RyOYtyoonqM56I69zlgA2';

export const COMPETITIONS = ['funday24', 'friendly', 'duminica23']
export const COMPETITION_NAMES: any = {
  'duminica23': 'FUNDAY 2023',
  'funday24': 'FUNDAY 2024',
  'friendly': 'FRIENDLY',
}